'use es6';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FILTER_CONSTS, FILTER_TYPES, FILTER_TYPES_OTHER } from '../constants/TopFilterConstants';
import { fetchPartnerTracks, fetchPublicTracks } from '../actions/TrackActions';
import { fetchPartnerLessons, fetchPublicLessons } from '../actions/LessonActions';
import { useSearchParam } from './searchParamHooks';
import getLang from 'I18n/utils/getLang';
import useTracksLessonsSearchQuery from './useTracksLessonsSearchQuery';
import { sortBy } from 'underscore';
import { useIsPartner } from '../features/partners';
import { UserTrackStatuses } from '../constants/TracksConstants';
export const useFetchFilters = (isPartnerPage = false, sortByDefault = false, status, context) => {
  const [selectedLanguages] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const [searchQuery] = useSearchParam(FILTER_TYPES_OTHER.SEARCH);
  const [selectedCategories] = useSearchParam(FILTER_TYPES_OTHER.CATEGORIES);
  const [selectedDurations] = useSearchParam(FILTER_TYPES.DURATION);
  const [selectedTools] = useSearchParam(FILTER_TYPES_OTHER.TOOLS);
  const [selectedLevels] = useSearchParam(FILTER_TYPES.LEVEL);
  const [selectedContentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const [selectedAwardTypes] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const [selectedSortBys] = useSearchParam('sortBy');
  const searchQueryParams = {
    durations: selectedDurations,
    languages: selectedLanguages.map(language => language.split('-')[0].toLowerCase()),
    categories: selectedCategories,
    hubSpotSoftware: selectedTools,
    levels: selectedLevels,
    contentTypes: selectedContentTypes.map(type => type === 'COURSE' ? 'TRACK' : type),
    search: searchQuery.length && searchQuery[0].length ? searchQuery[0] : null,
    partnersOnly: isPartnerPage
  };
  const tracksLessonsSearchQuery = useTracksLessonsSearchQuery(searchQueryParams);

  const sortFilterData = queryData => {
    let transformedData = queryData;

    switch (selectedSortBys[0]) {
      case FILTER_CONSTS.SORT_BYS.RECENTLY_ACCESSED:
        transformedData = sortBy(sortBy(transformedData, i => i.data.name), i => -i.updatedAt || 0);
        break;

      case FILTER_CONSTS.SORT_BYS.TITLE_ASC:
        transformedData = sortBy(transformedData, i => i.data.name);
        break;

      case FILTER_CONSTS.SORT_BYS.TITLE_DESC:
        transformedData = sortBy(transformedData, i => i.data.name).reverse();
        break;

      default:
        if (sortByDefault) {
          transformedData = sortBy(sortBy(transformedData, i => i.data.name), i => -i.updatedAt || 0);
        }

    }

    if (selectedAwardTypes.includes('ONLY_SHOW_CERTIFICATE_COURSES')) {
      transformedData = transformedData.filter(({
        data
      }) => data.certification);
    }

    if (status) {
      transformedData = transformedData.filter(item => {
        if (status === UserTrackStatuses.COMPLETED) {
          return item.status === status || item.status === UserTrackStatuses.EXPIRING_SOON;
        }

        return item.status === status;
      });
    }

    if (context) {
      transformedData = transformedData.filter(item => item.context ? item.context === context : true);
    }

    return transformedData;
  };

  return Object.assign({}, tracksLessonsSearchQuery, {
    tracksLessonsSearchQueryData: sortFilterData(tracksLessonsSearchQuery.tracksLessonsSearchQueryData),
    searchQueryParams
  });
};
export const useFetchTracksLessonsData = (partnerOnly = false) => {
  const dispatch = useDispatch();
  const [selectedLanguage] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const isPartnerPortal = useIsPartner();
  useEffect(() => {
    const fetchLanguage = selectedLanguage.length ? selectedLanguage[0].split('-')[0] : getLang();

    if (!partnerOnly) {
      dispatch(fetchPublicTracks(fetchLanguage));
      dispatch(fetchPublicLessons(fetchLanguage));
    }

    if (isPartnerPortal) {
      dispatch(fetchPartnerTracks(fetchLanguage));
      dispatch(fetchPartnerLessons(fetchLanguage));
    }
  }, [dispatch, isPartnerPortal, partnerOnly, selectedLanguage]);
};